<h1>Invalid Workflows</h1>

<div class="form-group">
  <div class="label">Jurisdiction</div>
  <select class="form-control" *ngIf="clients" [(ngModel)]="clientId" (ngModelChange)="searchWorkflows()">
    <option></option>
    <option *ngFor="let c of clients" [value]="c.id">{{ c.name}}</option>
  </select>
</div>

<app-loader *ngIf="loading"></app-loader>
<wm-workflow-list *ngIf="!loading && invalidWorkflows" [workflows]="invalidWorkflows" [clientId]="clientId" [loadGlobal]="true"></wm-workflow-list>
